<template>
  <b-row class="white-box pt-4 pb-4 mt-2 mr-2 ml-2" v-if="status_context_loaded">
    <b-container v-for="(tupple, index) in StatusInfoObject" :key="'string-' + index" fluid class="mb-4">
      <b-row class="gray-box pt-2 pr-0 pb-2 pl-3 m-0">
        {{ tupple[0] }}
      </b-row>
      <b-row class="pl-4">
        <b-col md sm="6" cols="6" v-for="(obj, i) in tupple[1]" :key="'obj-'+ index +'-' + i" class="p-0">
          <status-box
            :title="obj.title" :qtd="obj.qtd"
            :value="obj.value" :ticket="obj.ticket"/>
        </b-col>
      </b-row>
    </b-container>
  </b-row>
  <loader-box v-else height="491px" class="mr-2 mb-2 ml-2"/>
</template>

<script>
import StatusBox from '@/components/StatusBox.vue'
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    StatusBox,
    LoaderBox
  },
  computed: {
    status_context_loaded() { return this.$store.getters.status_context_loaded },
    StatusInfoObject() { return this.$store.getters.StatusInfoObject },
  }
}
</script>

<style>
  .position {
    top: -25px;
    left: 10px;
    position: relative;
    line-height: 0;
  }

  .gray-box {
    background-color: #F6F6F6;
    padding: 8px 4px 14px 4px;
    box-shadow: #00000008 0 0 6px 0;
  }
</style>
